import ObjaveForm from "./ObjaveForm";

const NovaObjava = () => {
  return <ObjaveForm searchData={{page: 1}} is_edit={false} />;
};
export default NovaObjava;
